<template>
  <div
    class="easy-ui form__field items-stretch"
    :class="rootClass"
  >
    <EasyFormFieldLabel
      v-if="props.label || slots['label']"
      :name="props.name"
      :label="props.label"
      :required="props.required"
      :label-tooltip="props.labelTooltip"
      :inline="props.inline"
      :disabled="props.disabled"
    >
      <template
        v-if="slots['label']"
        #label
      >
        <slot name="label" />
      </template>
    </EasyFormFieldLabel>

    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed, type HTMLAttributes, useAttrs, useSlots } from "vue";
import EasyFormFieldLabel from "@/src/easy-ui/components/EasyFormFieldLabel.vue";
import { VueSlots } from "@/src/shared/types/slot";
import { VueAttrs } from "@/src/shared/types/attrs";

interface Props {
  name: string;
  label?: string;
  required?: boolean;
  labelTooltip?: string;
  inline?: boolean;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  required: false,
  labelTooltip: "",
  label: undefined,
  inline: false,
  disabled: false,
});

const slots = useSlots() as VueSlots<["label"]>;

const attrs = useAttrs() as VueAttrs;

const rootClass = computed<HTMLAttributes["class"]>(() => attrs.class as HTMLAttributes["class"]);
</script>
